export const LOAD_USER_EVENT_LOG = 'LOAD_USER_EVENT_LOG';
export const LOAD_USER_EVENT_LOG_SUCCESS = 'LOAD_USER_EVENT_LOG_SUCCESS';
export const LOAD_USER_EVENT_LOG_FAIL = 'LOAD_USER_EVENT_LOG_FAIL';
